<template>
<div>
    <select class="form-control" v-model="shareId">
        <option value="">Ei osakevalintaa</option>
        <option v-for="share in shareOwners" 
            :key="share.shareId"
            :value="share.shareId">{{ share.shareNumber }} - {{ share.shareSeries }}</option>
    </select>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
        shareId: '',
    }),
    computed: {
        ...mapGetters({
            shareOwners: 'ecom/shareOwners',
        }),
    },
    methods: {
        getSelected() {
            const selected = this.shareOwners.filter(row => row.shareId == this.shareId)

            if (selected.length > 0) {
                return selected[0]
            }

            return null;
        },
    },
    mounted() {
        // trigger ecom store to load shareowner data
        // but read only from the getter
        this.$store.dispatch('ecom/getShareOwners')
    }
}
</script>